import { pgTable, uuid, timestamp, varchar, index, date } from 'drizzle-orm/pg-core';
import { users } from '../../user/models/users';

const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  external_id: uuid('external_id').defaultRandom().notNull().unique(),
  user_id: uuid('user_id').notNull().references(() => users.id),
  first_name: varchar('first_name', { length: 64 }).notNull(),
  last_name: varchar('last_name', { length: 64 }).notNull(),
  date_of_birth: date('date_of_birth').notNull(),
  sex: varchar('sex', { length: 20 }).notNull(),
  phone: varchar('phone', { length: 20 }).notNull(),
  emergency_contact_name: varchar('emergency_contact_name', { length: 64 }),
  emergency_contact_phone: varchar('emergency_contact_phone', { length: 20 }),
  date_created: timestamp('date_created', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
  date_modified: timestamp('date_modified', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
}

/**
 * @ignore
 * @internal
 */
export const patientProfiles = pgTable(
  'PatientProfiles', 
  schema,
  (table) => [
    index('patient_profile_external_id_idx').on(table.external_id),
    index('patient_profile_user_id_idx').on(table.user_id),
    index('patient_profile_phone_idx').on(table.phone),
  ]
);
